<template>
  <div>
    <p>订单状态饼状图</p>
    <div id="orderstatus" :style="{width: '100%', height: '300px'}" />
  </div>
</template>
<script>
import Vue from 'vue'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
export default {
  name: 'Hello',
  props: ["message5"],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  watch: {
    message5: function(newVal, oldVal) {
      let status = newVal[0].total;
      let status1 = newVal[1].total;
      let status2 = newVal[2].total;
      let status3 = newVal[3].total;
      let status4 = newVal[4].total;
      let status5 = newVal[5].total;
      this.drawLine(status,status1,status2,status3,status4,status5);
    }
  },
  methods: {
    drawLine(a,b,c,d,e,f) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('orderstatus'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          data: ['未接单', '已接单', '已签收', '已回单', '已结算', '已撤单']
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: a, name: '未接单' },
              { value: b, name: '已接单' },
              { value: c, name: '已签收' },
              { value: d, name: '已回单' },
              { value: e, name: '已结算' },
              { value: f, name: '已撤单' }
            ]
          }
        ]
      })
    }
  }
}
</script>
